export function isJwtExpired(token, skewSeconds = 10) {
  if (!token) {
    return true
  }

  try {
    const base64 = token.split('.')[1]
    if (!base64) {
      return false
    }

    const payload = JSON.parse(atob(base64.replace(/-/g, '+').replace(/_/g, '/')))
    if (!payload.exp) {
      return false
    }

    return payload.exp * 1000 <= Date.now() + skewSeconds * 1000
  } catch {
    return false
  }
}
